import React, { useContext } from 'react';

import classNames from 'classnames';
import ButtonSecondaryEllipse from '../ButtonSecondaryEllipse';
import { GradientContext } from '../../contexts/PageContexts';
import { motion } from 'framer-motion';
import { trackCarouselNextArrow } from '../../utils/dataLayer';
import styles from './SlideShowNav.module.scss';
import { useSwiper } from 'swiper/react';

const SlideShowNav = ({
    indicators = [],
    indicatorIndex,
    setIndicatorIndex,
    color,
    isVisible,
    emblaApi,
    carouselName = '',
    ...props
}) => {
    const gradient = useContext(GradientContext);

    // Get swiper from context if available (returns null if not in Swiper context)
    const swiper = useSwiper();

    const variants = {
        active: {
            transition: {
                duration: 1,
                type: 'spring',
                stiffness: 200,
            },
        },
    };

    const handleNext = () => {
        if (indicatorIndex === indicators.length - 1) {
            return;
        }

        trackCarouselNextArrow(carouselName);
        const newIndex = indicatorIndex + 1;
        setIndicatorIndex(newIndex);

        // Use Embla if provided, otherwise use Swiper
        if (emblaApi) {
            emblaApi.scrollTo(newIndex);
        } else if (swiper) {
            swiper.slideNext();
        }
    };

    const handlePrev = () => {
        if (indicatorIndex === 0) {
            return;
        }

        const newIndex = indicatorIndex - 1;
        setIndicatorIndex(newIndex);

        // Use Embla if provided, otherwise use Swiper
        if (emblaApi) {
            emblaApi.scrollTo(newIndex);
        } else if (swiper) {
            swiper.slidePrev();
        }
    };

    const rootClasses = classNames(styles['Root'], styles[gradient], {
        [styles['Visible']]: isVisible,
        [styles['White']]: color !== 'black',
    });

    return (
        <div className={rootClasses} {...props}>
            <div className={styles['SlideShowIndicatorContainer']}>
                {indicators.map((indicator, i) => {
                    return (
                        <div
                            key={i}
                            data-index={i}
                            data-indicator-index={indicatorIndex}
                            className={styles['SlideShowIndicator']}>
                            {i === indicatorIndex && (
                                <motion.div
                                    className={styles['Highlighted']}
                                    variants={variants}
                                    animate={i === indicatorIndex}
                                    layoutId="highlight"
                                />
                            )}
                        </div>
                    );
                })}
            </div>
            <div className={styles['SlideShowButtons']}>
                <ButtonSecondaryEllipse
                    icon={color !== 'black' ? 'icon-dropdown-arrow-left-black' : 'icon-dropdown-arrow-left-white'}
                    modifiers={[`${color !== 'black' && 'SlideShowNavWhite'}`, 'SlideShowNav']}
                    animateIcon={false}
                    onClick={handlePrev}
                    disabled={indicatorIndex === 0}>
                    <span className="sr-only"> Previous Item</span>
                </ButtonSecondaryEllipse>
                <ButtonSecondaryEllipse
                    icon={color !== 'black' ? 'icon-dropdown-arrow-right-black' : 'icon-dropdown-arrow-right-white'}
                    modifiers={[`${color !== 'black' && 'SlideShowNavWhite'}`, 'SlideShowNav']}
                    animateIcon={false}
                    onClick={handleNext}
                    disabled={indicatorIndex === indicators.length - 1}>
                    <span className="sr-only"> Next Item</span>
                </ButtonSecondaryEllipse>
            </div>
        </div>
    );
};

SlideShowNav.propTypes = {};

export default SlideShowNav;
